import { FC } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Formik } from "formik";
import { t } from "i18next";
import * as Yup from "yup";

import { InputWithCornerHint } from "@/shared/components/atoms/InputWithCornerHint";
import { ButtonPrimary } from "@/shared/components/atoms/ButtonPrimary";
import { selectUser } from "@/app/auth/auth.slice";
import { selectBranch } from "@/app/branchs/branch.slice";

// Esquema de validación con Yup
const validationSchema = Yup.object().shape({
  publicKeyPayment: Yup.string().required("Public key is required"),
  privateKeyPayment: Yup.string().required("Private key is required"),
  prodIntegrity: Yup.string().required("Prod integrity is required"),
});

export const PaymentMethods: FC<any> = () => {
  const { id } = useParams();
  const user = useSelector(selectUser);
  const branch = useSelector(selectBranch);

  // Verificar si user y user.branch están definidos
  if (!branch) {
    return <div>Loading...</div>;
  }

  return (
    <div className="flex flex-col items-center h-full w-full mt-2">
      <div className="w-full sm:max-w-full md:max-w-full lg:max-w-full xl:max-w-full 2xl:max-w-full mx-auto mb-8">
        <div className="flex sm:flex sm:items-start px-5 mt-6">
          <div className="flex-grow">
            <h1 className="text-lg font-semibold leading-6 text-gray-900">
              { branch.gateway ?               
                  branch.gateway.charAt(0).toUpperCase() +
                    branch.gateway.slice(1)
                : ""
              }
            </h1>
            <p className="mt-2 text-sm text-gray-700">
              Ingresa las llaves de{" "}
              { branch.gateway ?               
                  branch.gateway.charAt(0).toUpperCase() +
                    branch.gateway.slice(1)
                : ""
              }{" "}
              para activar los pagos
            </p>
          </div>
          <div className="mt-4 sm:ml-16 sm:mt-0"></div>
        </div>

        <div className="border-b border-gray-300 my-3"></div>

        <Formik
          enableReinitialize
          initialValues={{
            publicKeyPayment: branch.publicKeyPayment || "",
            privateKeyPayment: branch.privateKeyPayment || "",
            prodIntegrity: branch.prodIntegrity || "",
          }}
          validationSchema={validationSchema}
          onSubmit={(values, formikHelpers) => {
            console.log("VALORES DE REGISTRO", values);
            console.log("Usuario", user);

            /*
            if (currentBillEdit) {
              updateTaxId({
                ...values,
                branchId: id,
                id: currentBillEdit.id,
              });
            } else {
              createTaxId({
                ...values,
                branchId: id,
              });
            }
            formikHelpers.resetForm();
            setBillFormVisible(false);
            setCurrentTaxtIdEdit(undefined);
            */
          }}
        >
          {({
            handleChange,
            handleSubmit,
            errors,
            values,
            setFieldValue,
            resetForm,
          }) => (
            <form
              onSubmit={handleSubmit}
              className="w-full flex flex-col items-center justify-center px-5"
            >
              <div className="w-full grid grid-cols-1 md:grid-cols-4 gap-4 p-4">
                {(branch.gateway === "stripe" ||
                  branch.gateway == "wompi") && (
                  <>
                    <div className="col-span-1">
                      <InputWithCornerHint
                        label={t("branch.views.public_key_payment")}
                        span={t("general.mandatory")}
                        id="publicKeyPayment"
                        name="publicKeyPayment"
                        type="text"
                        placeholder={t("branch.views.public_key_payment")}
                        onChange={handleChange}
                        value={values.publicKeyPayment}
                        error={!!errors.publicKeyPayment}
                      />
                    </div>
                    <div className="col-span-1">
                      <InputWithCornerHint
                        label={t("branch.views.private_key_payment")}
                        span={t("general.mandatory")}
                        id="privateKeyPayment"
                        name="privateKeyPayment"
                        type="text"
                        placeholder={t("branch.views.private_key_payment")}
                        onChange={handleChange}
                        value={values.privateKeyPayment}
                        error={!!errors.privateKeyPayment}
                      />
                    </div>
                  </>
                )}

                {branch.gateway == "stripe" ||
                  (branch.gateway == "wompi" && <></>)}
                {branch.gateway == "wompi" && (
                  <>
                    <div className="col-span-1">
                      <InputWithCornerHint
                        label={t("branch.views.prod_integrity")}
                        span={t("general.mandatory")}
                        id="prodIntegrity"
                        name="prodIntegrity"
                        type="text"
                        placeholder={t("branch.views.prod_integrity")}
                        onChange={handleChange}
                        value={values.prodIntegrity}
                        error={!!errors.prodIntegrity}
                      />
                    </div>
                  </>
                )}

                {/* Botón "Guardar" centrado */}
                <div className="col-span-4 mt-5 flex justify-center">
                  <ButtonPrimary
                    className="mt-5"
                    text="Guardar"
                    size="large"
                    type="submit"
                  />
                </div>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
};
